import {SkeletonBlock} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const PriceAndBrandLoading: React.FC<{
  className?: string;
  style?: React.CSSProperties;
}> = ({className, style}) => {
  return (
    <SkeletonWrapper className={className} style={style}>
      <SkeletonBlock $width="30%" $height="30px" />
      <SkeletonBlock $width="35%" $height="50px" />
    </SkeletonWrapper>
  );
};

const SkeletonWrapper = styled.section`
  display: flex;
  justify-content: space-between;
`;
